<template>
    <div class="finish">
        <div class="finish__plate">
            <div class="finish__winner-title">

                {{currentGameState.winner.title}} победили!
            </div>

            <div class="finish__score-list-wrap">
                <div v-if="!wordIsShown"
                     class="finish__score-wrap">
                    <div class="finish__score"
                         v-for="(player, index) in players"
                         :key="index"

                    >
                        <div class="">{{player.title}}</div>
                        <div class="">{{player.score}}</div>
                    </div>
                </div>
                <img class="finish__score-list-wrap-img"
                     src="../assets/croc.svg"
                     alt="">
            </div>
            <GoBtn @click="newGame">Новая игра</GoBtn>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import confetti from 'canvas-confetti'
    import GoBtn from "../components/GoBtn";

    var duration = 15 * 1000;
    var animationEnd = Date.now() + duration;
    var defaults = {startVelocity: 30, spread: 360, ticks: 60, zIndex: 0};

    function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
    }


    export default {
        name: 'Finish',
        components: {GoBtn},
        mounted: function () {
            this.loadingData();
            var interval = setInterval(function () {
                var timeLeft = animationEnd - Date.now();

                if (timeLeft <= 0) {
                    return clearInterval(interval);
                }

                var particleCount = 50 * (timeLeft / duration);
                // since particles fall down, start a bit higher than random
                confetti(Object.assign({}, defaults, {
                    particleCount,
                    origin: {x: randomInRange(0.1, 0.3), y: Math.random() - 0.2}
                }));
                confetti(Object.assign({}, defaults, {
                    particleCount,
                    origin: {x: randomInRange(0.7, 0.9), y: Math.random() - 0.2}
                }));
            }, 250);



            window.AppRate.setPreferences({
                displayAppName: 'Крокодил',
                usesUntilPrompt: 1,
                promptAgainForEachNewVersion: false,
                reviewType: {
                    android: 'InAppBrowser'
                },
                storeAppURL: {

                    android: 'market://details?id=com.crocodil.rondi.app',
                },
                customLocale: {
                    title: "Не могли бы вы оценить %@?",
                    message: "Это займет не больше минуты. Спасибо за вашу поддержку!",
                    cancelButtonLabel: "Нет, спасибо",
                    laterButtonLabel: "Напомнить позже",
                    rateButtonLabel: "Оценить",
                    yesButtonLabel: "Да",
                    noButtonLabel: "Нет",
                    appRatePromptTitle: 'Вам нравится %@',
                    feedbackPromptTitle: 'Не могли бы дать нам обратную связь?',
                },

            });

            window.AppRate.promptForRating();


        },
        computed: {
            ...mapGetters([
                'currentGameState',
                'players',

            ])
        },
        methods: {
            newGame() {
                this.cleanAllData();
                this.$router.push('new-game')
            },
            ...mapActions([
                'cleanAllData',
                'loadingData'
            ])
        },

        data: function () {
            return {}
        },
    }
</script>

<style lang="scss">
    .finish {
        height: 100%;
        display: flex;
        min-height: 100vh;

        &__winner-title {
            text-align: center;
            font-size: 33px;
            font-weight: 900;
            margin-bottom: 200px;
        }
        &__plate {
            background: #fff;
            height: auto;
            bottom: 0;
            margin-top: auto;
            width: 100%;
            padding: 30px;
            border-radius: 40px 40px 0 0;
            position: relative;
        }

        &__score-wrap {

            border-radius: 30px;
            padding: 16px 24px;
            background-color: #f2f2f2;
            color: #999;
            position: relative;
            z-index: 500;

        }
        &__score-list-wrap {
            position: relative;
            margin: auto 0 30px;
            width: 100%;
        }
        &__score-list-wrap-img {
            position: absolute;
            top: -163px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 500;
        }

        &__score {
            width: 100%;
            padding: 10px 0;
            display: flex;
            font-size: 21px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e4e4e4;
            font-weight: 700;

            &--active {

                color: #333;
            }

            &:last-child {
                border-bottom: none;
            }
        }
    }
</style>
